import { assertNotEmpty, type Optional } from '@festina-life/core'

import type { IndexedParameterDefinitionCreateOperationWithMetaData } from '../../../uiModels/parameterOperations/types'
import { ParameterNameCell } from './ParameterNameCell'

type Props = {
  data: Optional<IndexedParameterDefinitionCreateOperationWithMetaData>
  column: number
  row?: number
}

export const ParameterRowCell = ({ data, column }: Props) => {
  if (!data) {
    return null
  }

  assertNotEmpty(data.internalOperation.entity)

  switch (column) {
    case 0:
      return <ParameterNameCell data={data} />
    case 1:
      return <div>{data.internalOperation.entity.parameterType}</div>
    case 2:
      return <div>{data.internalOperation.entity.environmentType}</div>
    default:
      throw new Error(
        `Invalid table column. No data available for column ${column}`,
      )
  }
}
